import { useMemo } from 'react';

import { useAuthSession } from '../useAuthSession';

interface UseBetaModeProps {
    active: boolean;
}

/**
 * Custom hook to be used for BetaMode
 * @returns
 * active: boolean -> Indicates if the beta mode is enabled
 */

const useBetaMode = (): UseBetaModeProps => {
    const { user: currentUser } = useAuthSession();

    const active = useMemo(
        () => Boolean(currentUser?.isBetaUser && currentUser?.isBetaMode),
        [currentUser],
    );

    return { active };
};

export default useBetaMode;
